import React from "react";
import "./ArticleFull.css";

const ForChild = () => {
  return (
    <div className="article-full">
      <h1 className="article-title">
        Оформление гражданства Бразилии для детей до 10 лет: ключевые моменты
      </h1>

      <p className="article-text">
        Бразилия предлагает упрощённый процесс натурализации для детей младше 10 лет, если один из родителей уже легально проживает в стране с постоянным видом на жительство или гражданством. Это отличная возможность для семей, обосновавшихся в Бразилии на длительный срок.
      </p>

      <h3 className="article-section-title">Условия для получения гражданства</h3>
      <p className="article-text">
        Ребёнок имеет право на бразильское гражданство при следующих условиях:
      </p>
      <ul className="article-list">
        <li>Один из родителей обладает гражданством Бразилии или постоянным резидентством (residência permanente).</li>
        <li>Ребёнок находится в стране на законных основаниях.</li>
        <li>Заявление подаётся родителями от имени ребёнка.</li>
      </ul>

      <h3 className="article-section-title">Необходимые документы</h3>
      <p className="article-text">
        Для подачи заявки обычно требуется подготовить такой набор документов:
      </p>
      <ul className="article-list">
        <li>Свидетельство о рождении ребёнка с апостилем и переводом на португальский язык.</li>
        <li>Документы родителя, подтверждающие его легальный статус в Бразилии (например, RNM или паспорт).</li>
        <li>Подтверждение проживания в стране (договор аренды, счёт за коммунальные услуги).</li>
        <li>Заявление от родителей с просьбой о натурализации ребёнка.</li>
      </ul>

      <h3 className="article-section-title">Сроки рассмотрения</h3>
      <p className="article-text">
        Оформление может занять от нескольких месяцев до года, в зависимости от региона и текущей нагрузки на миграционные службы. Заявку необходимо подавать через Министерство юстиции (Ministério da Justiça) или отделение Федеральной полиции (Polícia Federal).
      </p>

      <h3 className="article-section-title">Преимущества гражданства</h3>
      <p className="article-text">
        Получение бразильского гражданства открывает ребёнку доступ ко всем правам местных жителей: бесплатное образование, медицинское обслуживание, социальные льготы. Кроме того, это упрощает путешествия и получение документов в будущем, а также снимает ограничения на учёбу и работу.
      </p>

      <div className="article-note">
        <p className="article-note-text">
          ⚠️ <strong>Рекомендация:</strong> Условия могут варьироваться в зависимости от обстоятельств вашей семьи. Перед началом процесса стоит уточнить детали у миграционного адвоката или в ближайшем отделении Polícia Federal.
        </p>
      </div>
    </div>
  );
};

export default ForChild;